import { useLanguage } from '@/context/LanguageContext';
import { translations } from '@/data/translations';

export default function PrivacyPage() {
  const { t } = useLanguage();

  return (
    <div className="py-12 md:py-24 px-6 md:px-12 lg:px-24" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] tracking-tight mb-8">
          {t(translations.legal.privacyTitle)}
        </h1>
        <div
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: t(translations.legal.privacy.content) }}
        />
      </div>
    </div>
  );
}
